export const getRoute = (router, stepKeyName) => {
  const {
    route,
    query: { id }
  } = router

  const routesMapPerStep = {
    "general-information": "general-information",
    "technical-specs": "technical-specification",
    "request-f21": "request-f21",
    "sustainability": "sustainability",
    "budget": "budget",
    "timetable": "schedule",
    "human-resources": "human-resources",
    "comments": "comments"
  }

  if (route.includes("implementer")) {
    return `/implementer/submissions/${id}/edit/${routesMapPerStep[stepKeyName]}`
  } else {
    return `/admin/submissions/${id}/review/${routesMapPerStep[stepKeyName]}`
  }
}
